import React, {useRef, useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import TextBox from "./TextBox";
import {
    TextForm2FlatText,
    getHebrewTextInfo, ReadHebrewText, localStorageSetItem,localStorageGetItem
} from "./misc";
import {useStats} from './StatsContext';

import {removeNekudot} from "./nekudot";


const ExSpelling = forwardRef(({gameParams, revealed, addHistoryEntry}, ref) => {

        const {
            useStatsUseRef,
            markExDataAsFailure,
            markExDataAsSuccess,
            pickupRandomWordAndForm,
        } = useStats();

        const textType = gameParams.choice[1];

        const textBoxRefs = [useRef(), useRef()];

        // current gameMode
        const gameMode = useRef(gameParams.mode);
        const [letter1,letter2] = (gameParams.choiceIndex === 0
            ? ["ט","ת"]
            : (gameParams.choiceIndex===1
                ? ["כ","ח"]
                : (gameParams.choiceIndex===2
                    ? ["ה","א"]
                    : ["ק","כּ"])))

        const [currentText, setCurrentText] = useState(() => {
            return JSON.parse(localStorageGetItem('currentText')) || null;
        });

        // Managing the stats
        const statsRefKey = useStatsUseRef(textType, gameParams.mode);

        // This effect is for updating the two TextBox
        useEffect(() => {
            if (currentText === null) return;
            localStorageSetItem('currentText', JSON.stringify(currentText));
            const word = currentText.word;
            const hebrewForm = currentText.hebrewForm;
            const [hebrewText, hebrewPhonetic, frenchText, hebrewTextWithVowels] = currentText.flatText;

            const h = 0;
            const f = 1;
            const ft = hebrewTextWithVowels.slice(0, currentText.indexWithVowels) + "▮" +
                hebrewTextWithVowels.slice(currentText.indexWithVowels + currentText.letter.length);

            textBoxRefs[f].current.setFrenchText(frenchText)
            textBoxRefs[h].current.setHebrewText(ft,
                hebrewPhonetic, hebrewForm ? getHebrewTextInfo(word, hebrewForm) : "")

            if (revealed) {
                textBoxRefs[f].current.setShow([]);
                textBoxRefs[h].current.setHebrewText(hebrewTextWithVowels,
                    hebrewPhonetic, hebrewForm ? getHebrewTextInfo(word, hebrewForm) : "")
                textBoxRefs[h].current.setShow(['info','vowels'])
            }
            else {
                textBoxRefs[f].current.setShow([]);
                textBoxRefs[h].current.setShow(['info'])
            }
        }, [currentText, revealed])

        useImperativeHandle(ref, () => ({
            getFlags: () => {
                return {
                    hasRevealPhase: true,
                    hasHistoryButton: true,
                    isReadDisabled: false,
                    isQCM: true
                }
            },
            readHebrewText: () => {
                if (currentText)
                    ReadHebrewText(currentText.flatText[3]);
            },
            isNequdotActive: () => {
                return true
            },
            nequdotClick: (value) => {
                if (value) textBoxRefs[0].current.setShow(["info","vowels"])
                else textBoxRefs[0].current.setShow(["info"])
            },
            endEx: () => {
                localStorage.removeItem('currentText');
                localStorage.removeItem('textIndex');
            },
            isRecordingDisabled: () => {
                return true;
            },
            isRecordingSuccess: (text) => {
            },
            isEndEx: () => {
                return false;
            },
            getQCMList: () => {
                return [ {lang:'h',title: letter1}, {lang: 'h', title: letter2}]
            },
            getQCMSolution: () => {
                const solution = currentText.letter;
                return (solution=== letter1 ? 0 : 1);
            },
            /* Main function to notify success or failure */
            notifySuccess: (flagSuccess) => {
                let icon;
                if (flagSuccess) {
                    markExDataAsSuccess(statsRefKey, currentText.exData)
                    icon = "✅"
                } else {
                    markExDataAsFailure(statsRefKey, currentText.exData)
                    icon = "❌"
                }

                const [hebrewText, hebrewPhonetic, frenchText, hebrewTextWithVowels] = currentText.flatText;

                addHistoryEntry({
                    text1: removeNekudot(hebrewTextWithVowels) + " " + icon,
                    lang1: 'h',
                    text2: icon + " " + frenchText,
                    lang2: 'f',
                    textWithVowels: hebrewTextWithVowels
                });
            },

            // Function to select the next question
            nextEx: (firstEx = false) => {

                if (currentText && !firstEx) return;

                // WORD CASE
                const [word, hebrewForm] = pickupRandomWordAndForm(statsRefKey, gameParams.texts);
                const locations = (substring, string) => {
                    var a = [], i = -1;
                    while ((i = string.indexOf(substring, i + 1)) >= 0) a.push(i);
                    return a;
                }
                let l = Math.random() > 0.5 ? letter1 : letter2;
                let loc = locations(l,word.formes[hebrewForm][3])
                if (loc.length === 0) {
                    l = (l === letter1 ? letter2 : letter1)
                    loc = locations(l, word.formes[hebrewForm][3])
                }
                const indexWithVowels = loc[0]
                const exData = word.formes[hebrewForm];
                const flatText = TextForm2FlatText(word, hebrewForm);
                const shift = flatText[3].length-word.formes[hebrewForm][3].length

                setCurrentText({indexWithVowels: indexWithVowels+shift, letter: l, exData: exData, word: word, hebrewForm: hebrewForm, flatText: flatText});
            }
        }));


        return (
            <div className={"exercice-block"}>
                <div>
                    <TextBox ref={textBoxRefs[0]}/>
                </div>
                <div>
                    <TextBox ref={textBoxRefs[1]}/>
                </div>
            </div>
        )
    }
);


const ExSpellingGetInfo = ({action = null, mode = null, choiceIndex = null, texts = null}) => {

    if (action === null) {
        return [
            {
                "title": "Orthographe",
                "jsname": "ExSpellingGetInfo",
                "group": "spelling",
                "modes": ["t-t","kh-kh","h-h","k-k"],
                "choices": [["mots avec ט-ת", "words"], ["mots avec ח-כ", "words"],
                    ["mots avec א-ה", "words"],  ["mots avec כּ-ק", "words"]  ],
                "WordScoreMenuItem": [["ט-ת .Orth"], ["ח-כ .Orth"], ["א-ה .Orth"],  ["כּ-ק .Orth"]],
                "element": ExSpelling,
                "lessonsExcept": [0],
                "coeff": 0.2
            }
        ]
    }

    if (action === "filter") {
        if (choiceIndex === 0) {
            texts = texts.filter(w => Object.values(w.formes).every(ft => (ft[3].includes("ט") || ft[3].includes("ת"))));
        }
        if (choiceIndex === 1) {
            texts = texts.filter(w => Object.values(w.formes).every(
                ft => ((ft[3].includes("ח") || ft[3].includes("כ"))
                    && !ft[3].includes("כּ")
                    && ft[3][ft[3].length-1] !== "ח"
                )));
        }
        if (choiceIndex === 2) {
            texts = texts.filter(w => Object.values(w.formes).every(ft =>
                (ft[3].includes("ה") || ft[3].includes("א"))
            ));
        }
        if (choiceIndex === 3) {
            texts = texts.filter(w => Object.values(w.formes).every(ft =>
                (ft[3].includes("ק") || ft[3].includes("כּ"))
            ));
        }

        // We keep only a single form for each word
        return texts.map(w => {
            const {formes, ...w1 } = w;
            w1.formes = {}
            if ("inf" in w.formes)  w1.formes["inf"] = w.formes["inf"];
            else if ("ms" in w.formes)  w1.formes["ms"] = w.formes["ms"];
            else if ("fs" in w.formes)  w1.formes["fs"] = w.formes["fs"];
            else w1.formes[Object.keys(w.formes)[0]] = w.formes[Object.keys(w.formes)[0]]
            return w1
        })
    }
}

export {ExSpelling, ExSpellingGetInfo};
